module.exports = __webpack_public_path__ + "static/media/YM21_1.605bc3bd.jpg";